let _ = t => t,
  _t;
import styled from 'styled-components';
const HiddenInput = styled.input(_t || (_t = _`
    position: absolute;

    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;

    border: none;
    outline: none;
    opacity: 0;
`));
export default HiddenInput;